module.exports = __webpack_public_path__ + "static/media/aw-icon-sunrise.8adcd6d9.svg";